import { usePosStore } from '../store/posStore';
import type { AgregarItemRequest } from '../types/pos.types';

export const usePosCart = () => {
  const {
    ordenActual,
    ordenSaving,
    agregarItem,
    actualizarItem,
    eliminarItem,
    crearOrden,
    cancelarOrden,
    error,
  } = usePosStore();

  const addToCart = async (item: AgregarItemRequest) => {
    if (!ordenActual) {
      await crearOrden({ tipoOrden: 'RETAIL' });
    }

    const { ordenActual: orden } = usePosStore.getState();
    const existing = orden?.detalles?.find((d) => d.idArticulo === item.idArticulo);

    if (existing) {
      await actualizarItem(existing.idOrdenPosDetalle, {
        ...item,
        cantidad: existing.cantidad + item.cantidad,
      });
    } else {
      await agregarItem(item);
    }
  };

  const updateQuantity = async (idDetalle: number, item: AgregarItemRequest) => {
    await actualizarItem(idDetalle, item);
  };

  const removeFromCart = async (idDetalle: number) => {
    await eliminarItem(idDetalle);
  };

  const clearCart = async () => {
    await cancelarOrden();
  };

  return {
    items: ordenActual?.detalles ?? [],
    subTotal: ordenActual?.subTotal ?? 0,
    totalIGV: ordenActual?.totalIGV ?? 0,
    totalDescuento: ordenActual?.totalDescuento ?? 0,
    total: ordenActual?.total ?? 0,
    itemCount: ordenActual?.detalles?.length ?? 0,
    hasItems: (ordenActual?.detalles?.length ?? 0) > 0,
    ordenActual,
    saving: ordenSaving,
    error,
    addToCart,
    updateQuantity,
    removeFromCart,
    clearCart,
  };
};
